import { render } from "./UmlBanner.vue?vue&type=template&id=bebb38b6"
import script from "./UmlBanner.vue?vue&type=script&lang=js"
export * from "./UmlBanner.vue?vue&type=script&lang=js"

import "./UmlBanner.vue?vue&type=style&index=0&id=bebb38b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__